// extracted by mini-css-extract-plugin
var _1 = "stub_footer__2f45e";
var _2 = "stub_loader__89ba1";
var _3 = "stub_logo__fe23e";
var _4 = "stub_main__2671f";
var _5 = "stub_stub__cbc28";
export { _1 as "footer", _2 as "loader", _3 as "logo", _4 as "main", _5 as "stub" }
